import {
  Button,
  Card,
  CardBody,
  Input,
  Spinner,
  Tooltip,
  Typography,
} from "@material-tailwind/react"
import React, { useEffect, useState } from "react"
import { DetailDrawer } from "../../../components"
import moment from "moment"
import { DEFAULTPRIMARYCOLOR } from "../../../util"

import { toast } from "react-toastify"

import { CustomHeader } from "../../../components/headers/CustomHeader"

import { useQuery, useLazyQuery } from "@apollo/client"
import Papa from "papaparse"
import {
  COMMISSIONAGGREGATENEW,
  GET_LIST_PAYABLE_COMMISSIONS,
  GET_CONSOLIDATED_COMMISSIONS,
  GETBUSINESSCLASSES,
} from "../../../GraphQl/queries"
import { CommissionAggregateType } from "../../../types/query"
import CommissionDetail from "../../../components/Details/commission-detail"
import { DASHBOARD_USERTYPE } from "../../../types/role"
import ConfirmationDialog from "../../../config/confirmationbox"
import { FiDownloadCloud } from "react-icons/fi"
import { DriverModal } from "../../../components/modal/DriverModal"
import Otp from "../../../components/modal/enterOtpModal"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { getColorCode } from "../../../colorCodes"
import PerPageAndPagination from "../../../components/paginations/perpageAndPagination"
import { CustomModal } from "../../../components"
import dayjs from "dayjs";
import { range } from "lodash"


export type CommissionType = {
  commission_name: string
  payable_commission_id: string
  premium: string
  risk_id: string
  policy_no: string
  account_details: {
    branch: string
    bank_name: string
    acct_number: string
  }
  agent_first_name: string
  policy_number: string
  policy_id: string
  agent_last_name: string
  staff_name: string | null
  user_type: string
  created_at: string
  // commission_name: 'GCAP Commission',
  sub_class_id: string
  risk_or_sub_class_name: string
  reference_amount: number
  gross_amount: number
  outstanding_premium: number
  total_amount_paid: number
  total_premium_arrears: number
  rate: string
  net_amount: number
  total_tax_deductions: number
  status: string
  business_class_name: string
}

export type SubClassType = {
  id: string
  name: string
  status: string
  description: string
  business_class: {
    name: string
    description: string
  }
}

type filterOptions = "Paid" | "Arrears" | ""


const AgentCommission = () => {
  const [searchText, setSearchText] = useState("")
  const [loading, setLoading] = useState(false)
  const [openDrawer, setOpenDrawer] = React.useState(false)
  const [selectedRow, setSelectedRow] = useState<CommissionType>()
  const [openOtp, setOpenOtp] = useState(false)
  const [requestType, setRequestType] = useState("")
  const [selectedThick, setSelectedThick] = useState<CommissionType[] | []>([])
  const [policynumber, setPolicyNumber] = useState("")
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);

  const [bgTaskStatus, setBgTaskStatus] = useState<{
    running: boolean;
    total: number;
    processed: number;
    success: number;
    failed: number;
  }>({
    running: false,
    total: 0,
    processed: 0,
    success: 0,
    failed: 0,
  })

  if (selectedThick.length > 20) {
    toast.error("Limit of 20 commissions exceeded")
  }

  // const resolveCommission = () => {
  //   if (selectedThick.length <= 20) {
  //     setOpenOtp(true)
  //     setRequestType("multiple")
  //   } else {
  //     toast.error("Limit of 20 commissions exceeded")
  //   }
  // }

  const {
    companyId,
    user: stateUser,
    token,
  } = useSelector((state: RootState) => state.auth)

  const defaultStart = moment().subtract(1, "month").format("YYYY-MM-DDTHH:mm");
  const defaultEnd = moment().format("YYYY-MM-DDTHH:mm");
  const [startDate, setStartDate] = useState(defaultStart);
  const [endDate, setEndDate] = useState(defaultEnd);
  const [tempStartDate, setTempStartDate] = useState(defaultStart);
  const [tempEndDate, setTempEndDate] = useState(defaultEnd);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [searchData, setSearchData] = useState<CommissionType[] | undefined>(undefined)
  const [searchFilterStart, setSearchFilterStart] = useState("");
  const [searchFilterEnd, setSearchFilterEnd] = useState("");
  const filterOptions = ["Paid", "Arrears"]
  const [selectedFilter, setFilter] = useState<filterOptions>("")

  const onChangeFilter = (value: any) => {
    setFilter(value)
  }

  const handleStartDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setStartDate(formattedValue)
  }

  const handleEndDateChange = (event: any) => {
    const value = event.target.value
    const formattedValue = value + ":00Z" // Append seconds and 'Z' for timezone
    setEndDate(formattedValue)
  }


  const [fetchCom, {
    data: commissions,
    loading: loadingCommissions,
    refetch: refetchallcom,
  }] = useLazyQuery(GET_CONSOLIDATED_COMMISSIONS, {
    variables: {
      id: companyId,
      status_type: "pending",
      com_type: "BDC",
    },
  })
  // console.log("consolidated commissions",commissions)

  useEffect(() => {
    fetchCom({
      variables: {
        id: companyId,
        status_type: "pending",
        com_type: "BDC",
        start_date: defaultStart,
        end_date: defaultEnd
      }
    });
  }, [companyId]);

  const { data: classes, loading: loadingClass } = useQuery<{
    business_classes: {
      id: string
      image_url: string
      name: string
      description: string
    }[]
  }>(GETBUSINESSCLASSES)



  const [getListofCommissions, { data: commissionlist, loading: loadinglistcommissions, }] = useLazyQuery(GET_LIST_PAYABLE_COMMISSIONS);
  // console.log(commissionlist)

  const handleRowClick = (item: CommissionType) => {
    setSelectedRow(item)
    setPolicyNumber(item?.policy_number)
    getListofCommissions({ variables: { policy_number: item?.policy_number, com_type: "BDC" } });
    setOpen(true);
  }



  const handleFilterSearch = (e: any) => {
    setSearchText(e.target.value)
  }

  const handleSearch = () => {
    search()
  }

  const handleTempStartDateChange = (event: any) => {
    const value = event.target.value;
    if (value) {
      setTempStartDate(value); // Keep exact datetime-local input
    }
  };

  const handleTempEndDateChange = (event: any) => {
    const value = event.target.value;
    if (value) {
      setTempEndDate(value);
    }
  };


  const handleDateChange = () => {
    const start = dayjs(tempStartDate);
    const end = dayjs(tempEndDate);
    const diffInMonths = end.diff(start, 'month', true);

    setIsFilterLoading(true);

    if (searchData !== undefined) {
      setSearchFilterStart(tempStartDate)
      setSearchFilterEnd(tempEndDate)
      setIsFilterLoading(false);
    } else {
      if (diffInMonths > 3) {
        setTempStartDate(defaultStart);
        setTempEndDate(defaultEnd);
        toast.error("Date range cannot exceed 3 months.");
        setIsFilterLoading(false);
        return;
      }

      setTimeout(() => {
        fetchCom({
          variables: {
            start_date: tempStartDate,
            end_date: tempEndDate
          }
        });
        setIsFilterLoading(false);
      }, 1000);
    }
  };

  const reset = () => {
    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setTempStartDate(defaultStart);
    setTempEndDate(defaultEnd);
    setSearchFilterStart("");
    setSearchFilterEnd("");
    if (searchData === undefined) {
      fetchCom({
        variables: {
          start_date: defaultStart,
          end_date: defaultEnd
        }
      });
    }
  }


  const search = async () => {
    if (searchText) {
      try {
        setIsFilterLoading(true)
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/search-i2i-pending-commissions?company_id=${companyId}&search_term=${searchText}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )


        const req = await response.json()

        if (response.ok) {
          setSearchData(req.data)
          toast.success(req?.message)
        } else {
          // setSearchData("")
          toast.error(req?.message)
        }
        setIsFilterLoading(false)
      } catch (error) {
        // setSearchData("")
        toast.error("Could not perform search")
        setIsFilterLoading(false)
      }
    }
  }

  const filterData = (data: CommissionType) => {
    const lowerSearchText = searchText?.toLowerCase() || "";

    // Check if any of the fields contain the search text
    const isTextMatch =
      data?.staff_name?.toLowerCase()?.includes(lowerSearchText) ||
      data?.status?.toLowerCase()?.includes(lowerSearchText) ||
      data?.business_class_name?.toLowerCase()?.includes(lowerSearchText) ||
      data?.commission_name?.toLowerCase()?.includes(lowerSearchText) ||
      data?.risk_or_sub_class_name?.toLowerCase()?.includes(lowerSearchText) ||
      data?.policy_number?.toLowerCase()?.includes(lowerSearchText) ||
      data?.risk_id?.toLowerCase()?.includes(lowerSearchText) ||
      data?.reference_amount?.toString()?.includes(lowerSearchText) ||
      data?.agent_first_name?.toLowerCase()?.includes(lowerSearchText) ||
      data?.gross_amount?.toString()?.includes(lowerSearchText) ||
      data?.total_tax_deductions?.toString()?.includes(lowerSearchText) ||
      data?.net_amount?.toString()?.includes(lowerSearchText) ||
      data?.rate?.toLowerCase()?.includes(lowerSearchText) ||
      data?.agent_last_name?.toLowerCase()?.includes(lowerSearchText) ||
      data?.payable_commission_id?.toLowerCase()?.includes(lowerSearchText);

    // If "full" is typed, filter only where outstanding_premium is 0
    if (lowerSearchText === "full") {
      return data?.outstanding_premium <= 0;
    }

    if (lowerSearchText === "partial") {
      return data?.outstanding_premium > 0;
    }

    return isTextMatch;
  };

  function filterDate(item: CommissionType): boolean {
    const date = new Date(item?.created_at);
    const start = new Date(searchFilterStart);
    const end = new Date(searchFilterEnd);

    return date >= start && date <= end;
  }


  const paidFilter = (data: CommissionType) => {
    if (selectedFilter === "Paid") {
      return data?.outstanding_premium <= 0;
    } else if (selectedFilter === "Arrears") {
      return data?.outstanding_premium > 0;
    } else {
      return data
    }
  }

  // Filtered and paginated data for the current page

  const [currentPage, setCurrentPage] = useState(0)
  const [itemsPerPage, setItemsPerPage] = useState(10)


  useEffect(() => {
    if (searchText || startDate || endDate || itemsPerPage) {
      setCurrentPage(0)
    }
  }, [searchText, startDate, endDate, itemsPerPage])


  const filteredListItems = commissionlist?.view_payable_commissions_company


  const displayData = searchData !== undefined ? searchData : commissions?.view_payable_commissions_company

  const filtered = (searchFilterStart || searchFilterEnd) ? displayData?.filter(filterDate) : displayData
  const filteredItems = filtered?.filter(paidFilter)

  // ?.filter(filterData)
  // ?.filter((item: any) => {
  //   const normalizeDate = (date: string | Date): number => {
  //     const normalized = new Date(date);
  //     normalized.setHours(0, 0, 0, 0);
  //     return normalized.getTime();
  //   };

  //   const itemDate = normalizeDate(item.created_at);
  //   const from = startDate ? normalizeDate(startDate) : -Infinity;
  //   const to = endDate ? normalizeDate(endDate) : Infinity;

  //   return itemDate >= from && itemDate <= to;
  // });






  useEffect(() => {
    const totalAmount = filteredItems?.reduce(
      (sum: number, item: any) =>
        item.outstanding_premium <= 0.02
          ? sum + (item.net_amount || 0)
          : sum,
      0
    );

    setTotalPendingAmount(totalAmount);
  }, [commissions, searchText, filteredItems]);


  // const paginatedData = filteredItems?.slice(startIndex, endIndex)
  const endOffset = currentPage + itemsPerPage
  const paginatedData = filteredItems?.slice(currentPage, endOffset)
  const paginatedCommissionData = filteredListItems?.slice(currentPage, endOffset)

  const [open, setOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState<string[]>([])


  const handleSelectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;

    // Apply your selection conditions first
    const eligible = filteredItems
      ?.filter((p: any) => p?.outstanding_premium <= 0.02)
      ?.filter((p: any) => p?.loan_balance <= 0);

    if (!isChecked) {
      // Unselect all
      setSelectedRows([]);
      setSelectedThick([]);
      return;
    }

    // Limit selection to 20 max
    const limitedSelection = eligible.slice(0, 20);

    // Extract policy IDs
    const policyIds = limitedSelection.map((item: any) => item.policy_id);

    setSelectedRows(policyIds);
    setSelectedThick(limitedSelection);

    if (eligible.length > 20) {
      toast.error("Only the first 20 eligible commissions were selected.");
    }
  };

  const handleRowCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    row: CommissionType
  ) => {
    if (event.target.checked) {
      if (selectedThick.length >= 20) {
        toast.error("Limit of 20 commissions exceeded");
        return;
      }
      setSelectedRows([...selectedRows, row?.policy_id])
      setSelectedThick([...selectedThick, row])
    } else {
      setSelectedRows(
        selectedRows.filter((id) => id !== row?.policy_id)
      )
      setSelectedThick(
        selectedThick.filter(
          (obj) => obj.policy_id !== row.policy_id
        )
      )
    }
  }




  const handleDownload = () => {
    // Check if there is data to download
    if (paginatedData?.length === 0) {
      alert("No data to download.")
      return
    }
    // Define custom headers based on the selected filter
    if (selectedThick.length > 0) {
      const type = selectedThick?.map((item: any) => ({
        "commission type": item?.commission_name,
        "policy number": item?.policy_number,
        payee: item?.staff_name,
        class: item?.business_class_name,
        subclass: item.risk_or_sub_class_name,
        "risk ID": item?.risk_id,
        premium: item?.premium || 0,
        rate: item?.rate,
        "gross amount": `GHS ${(item?.gross_amount ?? 0).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "total tax deductions": `GHS ${(
          parseFloat(item?.total_tax_deductions as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "net amount": `GHS ${(
          parseFloat(item?.net_amount as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        status: item?.status,
      }))
      const firstItem = type[0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })

      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"pending-commissions"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
      return
    }
    if (searchText || startDate || endDate) {
      const type = filteredItems?.map((item: any) => ({
        "commission type": item?.commission_name,
        "policy number": item?.policy_number,
        payee: item?.staff_name,
        class: item?.business_class_name,
        subclass: item.risk_or_sub_class_name,
        "risk ID": item?.risk_id,
        premium: item?.premium || 0,
        rate: item?.rate,
        "gross amount": `GHS ${(item?.gross_amount ?? 0).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "total tax deductions": `GHS ${(
          parseFloat(item?.total_tax_deductions as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        "net amount": `GHS ${(
          parseFloat(item?.net_amount as any) ?? 0
        ).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
        status: item?.status,
      }))
      const firstItem = type[0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item: any) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })

      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"pending-commissions"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } else {
      const type = commissions?.view_payable_commissions_company?.map(
        (item: any) => ({
          "commission type": item?.commission_name,
          "policy number": item?.policy_number,
          payee: item?.staff_name,
          class: item?.business_class_name,
          subclass: item.risk_or_sub_class_name,
          "risk ID": item?.risk_id,
          premium: item?.premium || 0,
          rate: item?.rate,
          "gross amount": `GHS ${(item?.gross_amount ?? 0).toLocaleString(
            "en-US",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }
          )}`,
          "total tax deductions": `GHS ${(
            parseFloat(item?.total_tax_deductions as any) ?? 0
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          "net amount": `GHS ${(
            parseFloat(item?.net_amount as any) ?? 0
          ).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}`,
          status: item?.status,
        })
      )
      const firstItem = type[0]
      const originalHeaders = Object.keys(firstItem!)
      const upperHeaders = originalHeaders.map((h) => h.toUpperCase())
      // Transform data to match headers (Simplified)
      const transformedData = type?.map((item: any) => {
        const transformedItem: Record<string, string> = {};
        originalHeaders.forEach((originalKey, idx) => {
          const upperKey = upperHeaders[idx];
          transformedItem[upperKey] = String(item[originalKey as keyof typeof item]);
        });
        return transformedItem;
      });
      // Convert data to CSV format
      const csvData = Papa.unparse({
        fields: upperHeaders,
        data: transformedData!,
      })

      // Create a Blob and download link
      const blob = new Blob([csvData], { type: "text/csv" })
      const url = window.URL.createObjectURL(blob)
      // Create a download link
      const a = document.createElement("a")
      a.href = url
      a.download = `${"pending-commissions"}.csv`
      document.body.appendChild(a)
      // Trigger a click on the link to start the download
      a.click()
      // Cleanup
      window.URL.revokeObjectURL(url)
      document.body.removeChild(a)
    }
  }

  const [loadingCreating, setLoadingCreating] = useState(false)
  const [loadingRow, setLoadingRow] = useState("")
  const handleCreateSinglePaymentOrder = async (data: string) => {
    try {
      setLoadingCreating(true)
      setLoadingRow(data)
      const payload = JSON.stringify([
        {
          policy_id: data,
        },
      ])

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/create-payment-request-v2?usertype=${DASHBOARD_USERTYPE.company}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: payload, // Place the body outside the headers object
        }
      )
      if (!response.ok) {
        toast.error(" Error making payment order")

        return
      }

      refetchallcom()
      toast.success("Payment order created successfully")
    } catch (error) {
      toast.error(" Error making payment order")
    } finally {
      setLoadingCreating(false)
      setLoading(false)
    }
  }

  const handleCreateMultiplePaymentOrder = async () => {
    try {
      setLoadingCreating(true)

      const payload = JSON.stringify(
        selectedRows.map((row) => ({
          policy_id: row,
        }))
      )


      console.log(payload)

      console.log(token)

      // const response = await fetch(
      //   `${process.env.REACT_APP_BASE_URL}/create-payment-request-v2?usertype=${DASHBOARD_USERTYPE.company}`,
      //   {
      //     method: "POST",
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${token}`,
      //     },
      //     body: payload, // Place the body outside the headers object
      //   }
      // )


      // const req = await response.json()
      // setLoadingCreating(false)
      // if (response.ok) {
      //   refetchallcom()
      //   toast.success("Payment order created successfully")
      // } else {
      //   toast.error(req?.msg)
      // }
      // setLoadingCreating(false)
    } catch (error) {
      toast.error("Error deleting admin")
      setLoading(false)
    }
  }

  const handleCreateMultipleCommissionOrder = async () => {
    try {
      // Step 1: Initialize background task status

      setBgTaskStatus({
        running: true,
        total: selectedRows.length,
        processed: 0,
        success: 0,
        failed: 0,
      });




      const payload = JSON.stringify(
        selectedRows.map((row) => ({ policy_id: row }))
      );

      

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/create-commission-request-v2?usertype=${DASHBOARD_USERTYPE.company}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: payload,
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data?.msg || "Failed to start commission task");

      toast.info("Commission task started. Processing in background...");

      const parentTaskId = data.task_id;
      const pollInterval = 5000; // 5 seconds

      const pollTaskStatus = async () => {
        const statusRes = await fetch(
          `${process.env.REACT_APP_BASE_URL}/check-payment-tasks/${parentTaskId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const statusData = await statusRes.json();
        const tasks = statusData.tasks || [];

        const total = tasks.length;
        const success = tasks.filter((t: any) => t.state === "SUCCESS").length;
        const failed = tasks.filter((t: any) => t.state === "FAILURE").length;
        const processed = success + failed;

        setBgTaskStatus({
          running: statusData.parent_state !== "SUCCESS" && processed < total,
          total,
          processed,
          success,
          failed,
        });

        if (processed === total && total > 0) {
          toast.success(`Commission task completed! ${success} succeeded, ${failed} failed.`);

          // Wait 3 seconds before reloading
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          setTimeout(pollTaskStatus, pollInterval);
        }

      };

      pollTaskStatus();
    } catch (error: any) {
      toast.error(error.message || "Error starting commission task");
      setBgTaskStatus(prev => ({ ...prev, running: false }));
    }
  };


  const [showConfirmation, setShowConfirmation] = useState(false)
  const [chosenId, setChosenId] = useState("")
  const userData = stateUser
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      // const data: UserType = JSON.parse(userData)

      const colors = getColorCode(stateUser?.colors)

      setColors(colors)
    }
  }, [userData, stateUser?.colors])



  return (
    <>
      <CustomModal
        open={open}
        onClose={() => setOpen(false)}
        title="List of commissions"
        className="h-full overflow-scroll scrolls"
        showClose
        size={"xl"}
        children={
          <>
            <div className="w-full">
              <>
                <CardBody className="px-0 py-0">
                  <div
                    className="overflow-x-auto overflow-y-auto"
                    style={{ maxHeight: "42vh" }}
                  >
                    <table className="w-full bg-white min-w-max  table-auto">
                      <thead className="bg-white sticky z-50 top-0">
                        <tr>

                          {[
                            "Commission Type",
                            "Policy No.",
                            "Class",
                            "Subclass",
                            "Risk ID",
                            "Premium",
                            "NIC Fees",
                            "Rate",
                            "Gross Commission",
                            "Tax",
                            "Net Commission",
                            "Payee",
                            "Date created",
                            "Status",
                            "",
                            "",
                          ].map((head) => (
                            <th
                              key={head}
                              className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                            >
                              <Typography
                                color="black"
                                className="font-bold text-sm text-black leading-none opacity-70"
                              >
                                {head}
                              </Typography>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedCommissionData?.map((item: any, index: number) => {
                          const isLast = index === paginatedCommissionData?.length - 1

                          const className = isLast
                            ? "px-2 py-3  text-center"
                            : "px-2 py-3 border-b-2 border-blue-gray-50 text-center"

                          return (
                            <tr
                              key={index.toString()}
                              className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                            >
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs capitalize"
                                >
                                  {item?.commission_name}
                                </Typography>
                              </td>

                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs capitalize "
                                >
                                  {item?.policy_number}
                                </Typography>
                              </td>
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs"
                                >
                                  {item?.business_class_name}
                                </Typography>
                              </td>
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs"
                                >
                                  {item?.risk_or_sub_class_name}
                                </Typography>
                              </td>

                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs"
                                >
                                  {item?.risk_id}
                                </Typography>
                              </td>

                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs capitalize"
                                >
                                  GHS{" "}
                                  {(
                                    parseFloat(item?.reference_amount as any) ?? 0
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </td>


                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs"
                                >
                                  GHS{" "}
                                  {(45).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </td>
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs"
                                >
                                  {item?.rate}%
                                </Typography>
                              </td>
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs capitalize"
                                >
                                  GHS{" "}
                                  {(item?.gross_amount ?? 0).toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </Typography>
                              </td>
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs capitalize"
                                >
                                  GHS{" "}
                                  {(
                                    parseFloat(item?.total_tax_deductions as any) ??
                                    0
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </td>
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs capitalize"
                                >
                                  GH₵{" "}
                                  {(
                                    parseFloat(item?.net_amount as any) ?? 0
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}
                                </Typography>
                              </td>
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs capitalize "
                                >
                                  {`${item?.staff_name !== null
                                    ? item?.staff_name
                                    : ""
                                    } `}
                                </Typography>
                              </td>
                              <td className={className}>
                                <Typography
                                  variant="small"
                                  color="blue-gray"
                                  className="font-normal text-xs capitalize "
                                >
                                  {moment(item?.created_at).format("LLLL")}
                                </Typography>
                              </td>

                              <td className={className}>
                                <div className="flex flex-col gap-2">
                                  <Typography
                                    variant="small"
                                    color="blue-gray"
                                    className="text-xs capitalize font-bold"
                                    style={{
                                      fontWeight: "bolder",
                                      color:
                                        item?.status === "paid"
                                          ? "green" // If status is "paid", make text green
                                          : item?.status === "processing"
                                            ? "orange" // If status is "processing", make text yellow
                                            : item?.status === "pending"
                                              ? "blue" // If status is "pending", make text blue
                                              : "inherit", // Use default color if status doesn't match any condition
                                    }}
                                  >
                                    <span className="font-normal">
                                      {item?.status}
                                    </span>
                                  </Typography>
                                </div>
                              </td>

                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
                <hr />
                {loadinglistcommissions && (
                  <div className="mt-10 flex items-center justify-center">
                    <Spinner className="w-10 h-10" />
                  </div>
                )}

                {!paginatedCommissionData && !loadinglistcommissions && (
                  <div className="mt-10 flex items-center justify-center">
                    <Typography color="white" variant="h6">
                      No data found
                    </Typography>
                  </div>
                )}


                {paginatedCommissionData?.length! === 0 && !loadinglistcommissions && (
                  <div className="mt-10 flex items-center justify-center">
                    <Typography color="white" variant="h6">
                      No data found
                    </Typography>
                  </div>
                )}

                {paginatedCommissionData &&
                  paginatedCommissionData?.length !== 0 &&
                  !loadinglistcommissions && (
                    <PerPageAndPagination
                      customColor="black"
                      total={filteredItems?.length!}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      perPage={itemsPerPage}
                      setPerPage={setItemsPerPage}
                    />
                  )}
              </>



            </div>
          </>
        }
      />
      <DetailDrawer
        size={450}
        title="Commission detail"
        open={openDrawer}
        children={<>{<CommissionDetail content={selectedRow} />}</>}
        onClose={() => setOpenDrawer(false)}
      />
      <DriverModal
        title="Enter Your PIN"
        open={openOtp}
        size={"xs"}
        focus="message"
        onClose={() => setOpenOtp(false)}
        children={
          <Otp
            onConfirm={() =>
              requestType === "single"
                ? handleCreateSinglePaymentOrder(chosenId)
                : handleCreateMultipleCommissionOrder()
            }
            onClose={() => setOpenOtp(false)}
          />
        }
      // () => handleCreateSinglePaymentOrder(chosenId)
      />

      <ConfirmationDialog
        show={showConfirmation}
        setShow={setShowConfirmation}
        onConfirm={() => setOpenOtp(true)}
      />

      <div className="">
        <CustomHeader title="Commissions" />

        {bgTaskStatus.running && (
          <div className="mb-4 p-4 bg-gray-800 rounded-lg shadow-md">
            <p className="text-white mb-2 font-medium">
              Processing commissions:{" "}
              <span className="text-blue-400">
                {bgTaskStatus.processed}/{bgTaskStatus.total}
              </span>
            </p>

            <div className="w-full bg-gray-700 rounded-full h-3">
              <div
                className="bg-gradient-to-r from-blue-400 to-blue-600 h-3 rounded-full transition-all duration-500"
                style={{
                  width: `${(bgTaskStatus.processed / bgTaskStatus.total) * 100}%`,
                }}
              />
            </div>

            <p className="text-gray-400 text-sm mt-1">
              ✅ {bgTaskStatus.success} succeeded | ❌ {bgTaskStatus.failed} failed
            </p>
          </div>
        )}

        {!bgTaskStatus.running && bgTaskStatus.total > 0 && (
          <div className="mb-4 p-4 bg-gray-800 rounded-lg shadow-md">
            <p className="text-white mb-2 font-medium">
              Task completed! ✅{" "}
              <span className="text-green-400">{bgTaskStatus.success}</span> succeeded, ❌{" "}
              <span className="text-red-400">{bgTaskStatus.failed}</span> failed
            </p>
            <button
              onClick={() => refetchallcom()}
              className="mt-2 bg-blue-500 hover:bg-blue-600 text-white py-1 px-3 rounded"
            >
              Refresh Data
            </button>
          </div>
        )}
        <div className="mb-5 w-full grid-cols-1 grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 md:lg:gap-4 lg:gap-5">
          <Card
            className="bg-brand-success rounded-lg shadow-sm px-5 py-6 hover:shadow-md hover:cursor-pointer w-fit"
          >
            <div className="flex flex-row justify-between text-center">
              <div>
                <Typography className="text-3xl font-bold text-white capitalize tracking-wider">
                  {loadingCommissions ? (
                    <Spinner className="mb-2 text-white" />
                  ) : (
                    "GH₵" +
                    ((totalPendingAmount as any) ?? 0).toLocaleString(
                      "en-US",
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }
                    )
                  )}
                </Typography>
                <Typography className="text-sm uppercase font-normal text-white">
                  BDA Commissions to be paid
                </Typography>
              </div>
            </div>
          </Card>

        </div>

        {/* <div className="mt-7 flex flex-col md:flex-row lg:flex-row gap-2 items-center justify-between bg-white p-3 rounded-lg">
          <div className="flex flex-col md:flex-row lg:flex-row gap-3  w-full">
            <div className="flex flex-row items-center w-full ">
              <Typography className="w-28">Filter by</Typography>


              <div className="w-[30%]">
                <select
                  value={searchText}
                  onChange={handleFilterSearch}
                  className="h-10 capitalize bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option selected>
                    {loadingClass ? "Loading classes" : "Select class"}
                  </option>
                  {classes?.business_classes?.map((item) => (
                    <option
                      className="capitalize"
                      value={item?.name}
                      key={item?.id}
                      label={item?.name}
                    >
                      {item?.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <Button onClick={reset} className="capitalize">
                Reset
              </Button>
            </div>
          </div>
        </div> */}

        <div className="mt-8">
          <CardBody className="shadow-sm sticky px-0 py-0  rounded-3xl w-full">
            <div className=" w-full bg-black pt-5 rounded-t-2xl">
              <Typography
                variant="h6"
                style={{
                  color:
                    colors?.length! > 1
                      ? `${colors![0]?.toLowerCase()}`
                      : `${DEFAULTPRIMARYCOLOR}`,
                }}
                className="px-4 pb-4  font-bold  leading-none opacity-70 capitalize"
              >
                List of All Commissions for selected dates
                {commissions?.view_payable_commissions_company && (
                  <span className="text-white text-sm bg-admin-red p-1 rounded-md">
                    {filteredItems?.length}
                  </span>
                )}
              </Typography>
            </div>
            <div className=" w-full">
              <div className="w-full  flex flex-col gap-y-4 bg-white p-3">
                <div className="flex shrink-0 flex-col gap-2 justify-end sm:flex-row pl-10">
                  <Tooltip content="Export as CSV">
                    <Button
                      onClick={handleDownload}
                      variant="filled"
                      className="capitalize text-sm font-normal flex flex-wrap gap-2"
                      size="sm"
                    >
                      <FiDownloadCloud size={20} />
                      <span>Download csv</span>
                    </Button>
                  </Tooltip>
                </div>
                <div className="flex flex-col px-5 pb-6 items-center">
                  <div className="w-full p-3 flex gap-x-2 items-center flex-col 2xl:flex-row gap-y-3 mb-5">
                    {selectedRows?.length > 0 && (
                      <Button
                        onClick={() => {
                          setOpenOtp(true)
                          setRequestType("multiple")
                        }}
                        size="sm"
                        color="teal"
                        className="text-xs font-normal capitalize bg-brand-cyan"
                      >
                        {loadingCreating ? "loading..." : `Request to pay ${selectedThick.length}`}
                      </Button>
                    )}

                    <div className="w-full flex flex-row gap-x-2">
                      {" "}
                      {/* Added flex-1 class */}
                      <Input
                        crossOrigin="anonymous"
                        label="Search"
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value)
                          if (e.target.value === "") {
                            setSearchText("")
                            setSearchData(undefined)
                            setSearchFilterStart("")
                            setSearchFilterEnd("")
                          }
                        }}
                        icon={<i className="fas fa-search text-base"></i>}
                      />
                      <Button
                        onClick={handleSearch}
                        variant="filled"
                        className="capitalize text-sm font-normal flex flex-wrap items-center justify-center"
                        size="sm"
                      >
                        <span>Search</span>
                      </Button>
                    </div>
                  </div>

                  <div className="flex flex-col xl:flex-row gap-3 mb-0 items-center w-fit">
                    <div className="flex flex-row items-center w-full lg:w-1/2 mr-3">
                      <div className="flex flex-row items-center space-x-2">
                        <label className="w-full font-semibold text-gray-700">Filter by</label>
                        <select
                          value={selectedFilter}
                          onChange={(e) => onChangeFilter(e.target.value)}
                          className="h-10 capitalize bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg !border-t-blue-gray-200 focus:!border-t-gray-900 w-fit p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        >
                          <option selected disabled value="">
                            Payment Status
                          </option>
                          <option selected value="">
                            All
                          </option>
                          {filterOptions?.map((item) => (
                            <option
                              className="capitalize"
                              value={item}
                              key={item}
                              label={item}
                            >
                              {item}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="flex flex-row items-center space-x-2">
                      <div className="flex items-center space-x-2">
                        <label className="font-semibold text-gray-700">
                          From
                        </label>
                        <Input
                          type="datetime-local"
                          value={tempStartDate} // Remove 'Z' for input value
                          onChange={handleTempStartDateChange}
                          size="md"
                          className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                          labelProps={{
                            className: "before:content-none after:content-none",
                          }}
                        />
                      </div>
                      <div className="flex items-center space-x-2">
                        <label className="font-semibold text-gray-700">To</label>
                        <Input
                          type="datetime-local"
                          value={tempEndDate} // Remove 'Z' for input value
                          onChange={handleTempEndDateChange}
                          size="md"
                          className="!border-t-blue-gray-200 focus:!border-t-gray-900 w-full"
                          labelProps={{
                            className: "before:content-none after:content-none",
                          }}
                        />
                      </div>
                      <div className="flex shrink-0 flex-col gap-4 justify-end sm:flex-row">
                        <Tooltip content="Apply Date filters">
                          <Button
                            onClick={handleDateChange}
                            variant="filled"
                            className="capitalize text-sm font-normal flex flex-wrap align-middle"
                            size="sm"
                          >
                            <span>Filter</span>
                          </Button>
                        </Tooltip>
                        <Tooltip content="Clear All Date filters">
                          <Button
                            onClick={reset}
                            variant="filled"
                            className="capitalize text-sm bg-red-400 font-normal flex flex-wrap"
                            size="sm"
                          >
                            <span>Clear</span>
                          </Button>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {loadingCreating ? (
              <div className="mt-10 flex items-center justify-center">
                <Spinner className="w-10 h-10" />
              </div>
            ) : <CardBody className="px-0 py-0">
              <div
                className="overflow-x-auto overflow-y-auto"
                style={{ maxHeight: "42vh" }}
              >
                <table className="w-full bg-white min-w-max  table-auto">
                  <thead className="bg-white sticky z-50 top-0">
                    <tr>
                      <th className="border-y border-blue-gray-100 text-black bg-gray-50/50 p-4">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={
                            selectedRows.length === paginatedData?.length
                            // paginatedData?.filter(
                            //   (p: any) => p?.outstanding_premium <= 0
                            // ).length
                          }
                        />
                      </th>
                      {[
                        "Commission Type",
                        "Policy No.",
                        "Class",
                        "Subclass",
                        "Risk ID",
                        "Premium",
                        "Premium Paid",
                        "Outstanding Premium",
                        "Moovon Loan Fee",
                        "Moovon Oustanding Loan",
                        "NIC Fees",
                        "Rate",
                        "Gross Commission",
                        "Tax",
                        "Net Commission",
                        "Payee",
                        "Date created",
                        "Status",
                        "",
                        "",
                      ].map((head) => (
                        <th
                          key={head}
                          className=" border-y border-blue-gray-100 text-black bg-gray-50/50 p-4"
                        >
                          <Typography
                            color="black"
                            className="font-bold text-sm text-black leading-none opacity-70"
                          >
                            {head}
                          </Typography>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData?.map((item: any, index: number) => {
                      const isLast = index === paginatedData?.length - 1



                      const className = isLast
                        ? "px-2 py-3  text-center"
                        : "px-2 py-3 border-b-2 border-blue-gray-50 text-center"

                      return (
                        <tr
                          key={index.toString()}
                          className="hover:bg-gray-100 transition-all hover:cursor-pointer"
                        >
                          <td className={className}>
                            <input
                              type="checkbox"
                              onChange={(event) =>
                                handleRowCheckboxChange(event, item)
                              }
                              checked={selectedRows.includes(
                                item.policy_id
                              )}
                              disabled={
                                (item?.outstanding_premium as any) > 0.02
                              }
                            />
                          </td>

                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              {item?.commission_name}
                            </Typography>
                          </td>

                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize "
                            >
                              {item?.policy_number}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs"
                            >
                              {item?.business_class_name}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs"
                            >
                              {item?.risk_or_sub_class_name}
                            </Typography>
                          </td>

                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs"
                            >
                              {item?.risk_id}
                            </Typography>
                          </td>

                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS{" "}
                              {(
                                parseFloat(item?.premium as any) ?? 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS{" "}
                              {(
                                parseFloat(item?.total_amount_paid as any) ?? 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className={`font-normal text-xs capitalize p-1 ${parseFloat(item?.outstanding_premium as any) >
                                0.02
                                ? "text-red-500 font-bold"
                                : ""
                                }`}
                            >
                              GHS{" "}
                              {(
                                parseFloat(
                                  item?.outstanding_premium as any
                                ) ?? 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>

                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className={`font-normal text-xs capitalize p-1 
                                `}
                            >
                              GHS{" "}
                              {(
                                Number(item?.loan_fee) || 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}

                            </Typography>
                          </td>

                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className={`font-normal text-xs capitalize p-1 ${parseFloat(item?.loan_balance as any) >
                                0
                                ? "text-red-500 font-bold"
                                : ""
                                }`}
                            >
                              GHS{" "}
                              {(
                                parseFloat(
                                  item?.loan_balance as any
                                ) ?? 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>


                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs"
                            >
                              GHS{" "}
                              {(45).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs"
                            >
                              {item?.rate}%
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS{" "}
                              {(item?.gross_amount ?? 0).toLocaleString(
                                "en-US",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GHS{" "}
                              {(
                                parseFloat(item?.total_tax_deductions as any) ??
                                0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize"
                            >
                              GH₵{" "}
                              {(
                                parseFloat(item?.net_amount as any) ?? 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize "
                            >
                              {`${item?.staff_name !== null
                                ? item?.staff_name
                                : ""
                                } `}
                            </Typography>
                          </td>
                          <td className={className}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal text-xs capitalize "
                            >
                              {moment(item?.created_at).format("LLLL")}
                            </Typography>
                          </td>

                          <td className={className}>
                            <div className="flex flex-col gap-2">
                              <Typography
                                variant="small"
                                color="blue-gray"
                                className="text-xs capitalize font-bold"
                                style={{
                                  fontWeight: "bolder",
                                  color:
                                    item?.status === "paid"
                                      ? "green" // If status is "paid", make text green
                                      : item?.status === "processing"
                                        ? "orange" // If status is "processing", make text yellow
                                        : item?.status === "pending"
                                          ? "blue" // If status is "pending", make text blue
                                          : "inherit", // Use default color if status doesn't match any condition
                                }}
                              >
                                <span className="font-normal">
                                  {item?.status}
                                </span>
                              </Typography>
                            </div>
                          </td>
                          <div className="flex justify-between whitespace-nowrap z-50 bg-white sticky right-0">
                            <td className={className}>
                              <div className="flex items-center gap-1">
                                <Button
                                  onClick={() => handleRowClick(item)}
                                  size="sm"
                                  color="teal"
                                  className="text-xs font-normal capitalize bg-brand-teal"
                                >
                                  View details
                                </Button>

                                <Button
                                  onClick={() => {
                                    setRequestType("single")
                                    setChosenId(item?.policy_id)
                                    setShowConfirmation(true)
                                  }}
                                  size="sm"
                                  disabled={
                                    loadingRow ===
                                    item?.payable_commission_id ||
                                    parseFloat(
                                      item?.outstanding_premium as any
                                    ) > 0.02
                                    || parseFloat(
                                      item?.loan_balance as any
                                    ) > 0
                                  }
                                  color="teal"
                                  className="text-xs font-normal capitalize bg-brand-cyan"
                                >
                                  {loadingCreating &&
                                    loadingRow === item.payable_commission_id
                                    ? "Loading"
                                    : "Request to pay"}
                                </Button>
                              </div>
                            </td>
                          </div>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </CardBody>
            }

            {(loadingCommissions || isFilterLoading) && (
              <div className="mt-10 flex items-center justify-center">
                <Spinner className="w-10 h-10" />
              </div>
            )}

            {!paginatedData && !loadingCommissions && (
              <div className="mt-10 flex items-center justify-center">
                <Typography color="white" variant="h6">
                  No data found
                </Typography>
              </div>
            )}
          </CardBody>

          {paginatedData?.length! === 0 && !loadingCommissions && (
            <div className="mt-10 flex items-center justify-center">
              <Typography color="white" variant="h6">
                No data found
              </Typography>
            </div>
          )}

          {paginatedData &&
            paginatedData?.length !== 0 &&
            !loadingCommissions && (
              <PerPageAndPagination
                customColor="white"
                total={filteredItems?.length!}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                perPage={itemsPerPage}
                setPerPage={setItemsPerPage}
              />
            )}
        </div>
      </div>
    </>
  )
}

export default AgentCommission